import React from "react";
import CreateBrandPage from "../components/popups/CreateBrandPage";
import CreateBranchPage from "../components/popups/CreateBranchPage";
import CreateScreenPage from "../components/popups/CreateScreenPage";
import ScreenBrightnessPage from "../components/popups/ScreenBrightnessPage";
import CreateCampaignPage from "../components/popups/CreateCampaignPage";
import CreateTimelinePage from "../components/popups/CreateTimelinePage";
import CreatePlaylistPage from "../components/popups/CreatePlaylistPage";
import CreateWidgetInstancePage from "../components/popups/CreateWidgetInstancePage";
import PlaylistSelectorPopup from "../components/popups/PlaylistSelectorPopup";
import EditLayoutPopup from "../components/popups/EditLayoutPopup";
import AssignAndPublishPage from "../components/popups/AssignAndPublishPage";
import FilesUploader from "../components/popups/FilesUploader";
import ScaleSelectorPopup from "../components/popups/ScaleSelectorPopup";
import PairScreenPage from "../components/popups/PairScreenPage";
import CreateURLMediaView from "../components/views/CreateURLMediaView";
import CreateStreamingURLMediaView from "../components/views/CreateStreamingURLMediaView";
import { Divider, Grid } from "antd";
import ScreenStreamingPopup from "../components/popups/ScreenStreamingPopup";
import PublishingScheduleManagerPage from "../components/popups/PublishingScheduleManagerPage";
import UserManagermentPopup from "../components/popups/UserManagermentPopup";
import RoleManagermentPopup from "../components/popups/RoleManagermentPopup";
import CreateEventTimelinePage from "../components/popups/CreateEventTimelinePage";
import CreateScreenEventPage from "../components/popups/CreateScreenEventPage";
import ScreenEventPlaylistModuleEditor from "../components/ScreenEventPlaylistModuleEditor";
import AssignAndPublishEventPage from "../components/popups/AssignAndPublishEventPage";
import AssignToPlaylistsView from "../components/views/AssignToPlaylistsView";
import EditImageVideoMediaView from "../components/views/EditImageVideoMediaView";
import { useProLanguage, PRO_TRANSLATIONS } from "../global/ProLanguageContext";
import DuplicatePlaylistPage from "../components/popups/DuplicatePlaylistPage";
import DuplicateTimelinePage from "../components/popups/DuplicateTimelinePage";
import DuplicateCampaignPage from "../components/popups/DuplicateCampaignPage";
import ForgotPasswordPopup from "../components/popups/ForgotPasswordPopup";

const PairScreenPopupContent = ({ screenData, onSuccess }) => {
  const { lang } = useProLanguage();
  return (
    <PairScreenPage
      key={`$pairscreen${Math.random()}`}
      data={screenData}
      lang={lang}
      onSuccess={onSuccess}
    />
  );
};

const EditImageVideoPopupContent = ({ mediaData, branches, callback }) => {
  const { lang } = useProLanguage();
  const t = (PRO_TRANSLATIONS[lang] || PRO_TRANSLATIONS.en).editMedia;
  const screens = Grid.useBreakpoint();
  const isMobile = screens.sm === false;
  const typeLabel =
    mediaData.FileType?.toLocaleLowerCase() === "video"
      ? t.labelVideo
      : t.labelImage;
  return (
    <div
      style={{
        width: "100%",
        maxWidth: 500,
        boxSizing: "border-box",
        padding: isMobile ? "20px 16px" : "30px 45px",
      }}
    >
      <span style={{ fontSize: isMobile ? 20 : 26, fontWeight: 500 }}>
        {t.editTitle(typeLabel)}
      </span>
      <Divider />
      <EditImageVideoMediaView
        key={`editimgvid_${mediaData.FileID}`}
        data={mediaData}
        branches={branches}
        onSuccess={callback}
      />
    </div>
  );
};

const EditWebPopupContent = ({ mediaData, branches, callback }) => {
  const { lang } = useProLanguage();
  const t = (PRO_TRANSLATIONS[lang] || PRO_TRANSLATIONS.en).editMedia;
  const screens = Grid.useBreakpoint();
  const isMobile = screens.sm === false;
  return (
    <div
      style={{
        width: "100%",
        maxWidth: 600,
        boxSizing: "border-box",
        padding: isMobile ? "20px 16px" : "30px 45px",
      }}
    >
      <span style={{ fontSize: isMobile ? 20 : 26, fontWeight: 500 }}>
        {t.editTitle(t.labelWebsite)}
      </span>
      <Divider />
      <CreateURLMediaView
        key={`url_${mediaData.FileID}`}
        data={mediaData}
        branches={branches}
      />
    </div>
  );
};

const EditStreamingPopupContent = ({ mediaData, branches }) => {
  const { lang } = useProLanguage();
  const t = (PRO_TRANSLATIONS[lang] || PRO_TRANSLATIONS.en).editMedia;
  const screens = Grid.useBreakpoint();
  const isMobile = screens.sm === false;
  return (
    <div
      style={{
        width: "100%",
        maxWidth: 600,
        boxSizing: "border-box",
        padding: isMobile ? "20px 16px" : "30px 45px",
      }}
    >
      <span style={{ fontSize: isMobile ? 20 : 26, fontWeight: 500 }}>
        {t.editTitle(t.labelStreaming)}
      </span>
      <Divider />
      <CreateStreamingURLMediaView
        key={`streamingurl_${mediaData.FileID}`}
        data={mediaData}
        branches={branches}
      />
    </div>
  );
};

class PopupManager extends React.Component {
  static onModalUpdate = (visible, content, callback = () => {}) => {};
  static _savedOnClose = false;

  static launchPublishingScheduleManagerPopup = (
    screenData,
    callback = () => {},
  ) => {
    PopupManager.onModalUpdate(
      true,
      <PublishingScheduleManagerPage
        key={`schedule_${screenData.ScreenID}`}
        screendata={screenData}
      ></PublishingScheduleManagerPage>,
      callback,
    );
  };

  static launchUserManagementPopup = (userData, callback = () => {}) => {
    PopupManager.onModalUpdate(
      true,
      <UserManagermentPopup
        key={`user_${userData ? userData.user.userid : "annonymous"}`}
        data={userData}
      ></UserManagermentPopup>,
      callback,
    );
  };
  static launchRoleManagementPopup = (userData, callback = () => {}) => {
    PopupManager.onModalUpdate(
      true,
      <RoleManagermentPopup
        key={`$rollManagement${Math.random()}`}
      ></RoleManagermentPopup>,
      callback,
    );
  };
  static launchScreenStreamingPopup = (stream, callback = () => {}) => {
    PopupManager.onModalUpdate(
      true,
      <ScreenStreamingPopup
        key={`screenstreaming${Math.random()}`}
        data={stream}
      ></ScreenStreamingPopup>,
      callback,
    );
  };
  static launchForgotPasswordPopup = (stream, callback = () => {}) => {
    PopupManager.onModalUpdate(
      true,
      <ForgotPasswordPopup
        key={`ForgotPasswordPopup${Math.random()}`}
      ></ForgotPasswordPopup>,
      callback,
      "min(460px, 90vw)",
    );
  };
  static launchEditImageVideoFilePopup = (
    mediaData,
    callback = () => {},
    branches = [],
  ) => {
    PopupManager.onModalUpdate(
      true,
      <EditImageVideoPopupContent
        mediaData={mediaData}
        branches={branches}
        callback={callback}
      />,
      callback,
    );
  };
  static launchEditWebFilePopup = (
    mediaData,
    callback = () => {},
    branches = [],
  ) => {
    console.log("launchEditWebFilePopup " + JSON.stringify(mediaData));
    PopupManager.onModalUpdate(
      true,
      <EditWebPopupContent
        mediaData={mediaData}
        branches={branches}
        callback={callback}
      />,
      callback,
    );
  };
  static launchEditStreamingURLFilePopup = (
    mediaData,
    callback = () => {},
    branches = [],
  ) => {
    PopupManager.onModalUpdate(
      true,
      <EditStreamingPopupContent mediaData={mediaData} branches={branches} />,
      callback,
    );
  };
  static launchAssignFileToPlaylistsPopup = (
    mediaData,
    callback = () => {},
  ) => {
    // console.log("launchPairscreenPopup " + JSON.stringify(mediaData))
    PopupManager.onModalUpdate(
      true,
      <AssignToPlaylistsView
        key={`assignfiletoplaylists_${mediaData.FileID}`}
        visible={true}
        data={mediaData}
        onAssign={callback}
        onCancel={() => PopupManager.closePopup()}
      />,
      callback,
    );
  };
  static launchPairscreenPopup = (screenData, callback = () => {}) => {
    // console.log("launchPairscreenPopup")
    PopupManager.onModalUpdate(
      true,
      <PairScreenPopupContent screenData={screenData} onSuccess={callback} />,
      () => {},
    );
  };
  static launchScaleSelectorPopup = (mediaData, callback = () => {}) => {
    // console.log("launchFileUploader")
    PopupManager.onModalUpdate(
      true,
      <ScaleSelectorPopup
        key={"scalelistselector" + Math.random()}
        mediaData={mediaData}
      ></ScaleSelectorPopup>,
      callback,
    );
  };
  static launchFileUploader = (
    callback = () => {},
    selectedFolderID = null,
  ) => {
    console.log("launchFileUploader : selectedFolderID " + selectedFolderID);
    // console.log("launchFileUploader")
    PopupManager.onModalUpdate(
      true,
      <FilesUploader
        key={`fileuploader_${Math.random()}`}
        selectedFolderID={selectedFolderID}
      ></FilesUploader>,
      callback,
    );
  };
  static launchEditLayoutPopup = (timelineLayoutData, callback = () => {}) => {
    PopupManager.onModalUpdate(
      true,
      <EditLayoutPopup
        key={"editlayout" + Math.random()}
        timelineLayoutData={timelineLayoutData}
      ></EditLayoutPopup>,
      callback,
    );
  };
  static launchPlaylistSelectorPopup = (
    brandid,
    onItemSelected = () => {},
    callback = () => {},
  ) => {
    PopupManager.onModalUpdate(
      true,
      <PlaylistSelectorPopup
        key={"playlistselector" + Math.random()}
        brandid={brandid}
        onItemSelected={onItemSelected}
      ></PlaylistSelectorPopup>,
      callback,
    );
  };

  static launchCreatePlaylistPopup = (
    onPlaylistCreated = () => {},
    callback = () => {},
  ) => {
    PopupManager.onModalUpdate(
      true,
      <CreatePlaylistPage
        key={"createplaylist" + Math.random()}
        onPlaylistCreated={onPlaylistCreated}
      ></CreatePlaylistPage>,
      callback,
    );
  };
  static launchEditPlaylistPopup = (playlistData, callback = () => {}) => {
    PopupManager.onModalUpdate(
      true,
      <CreatePlaylistPage
        key={"editplaylist" + Math.random()}
        data={playlistData}
      ></CreatePlaylistPage>,
      callback,
    );
  };
  static launchDuplicatePlaylistPopup = (playlistData, callback = () => {}) => {
    PopupManager.onModalUpdate(
      true,
      <DuplicatePlaylistPage
        key={"editplaylist" + Math.random()}
        data={playlistData}
      ></DuplicatePlaylistPage>,
      callback,
    );
  };
  static launchCreateCampaignPopup = (callback = () => {}) => {
    PopupManager.onModalUpdate(
      true,
      <CreateCampaignPage
        key={"createcampaign" + Math.random()}
      ></CreateCampaignPage>,
      callback,
    );
  };
  static launchDuplicateCampaignPopup = (campaignData, callback = () => {}) => {
    PopupManager.onModalUpdate(
      true,
      <DuplicateCampaignPage
        key={`${campaignData ? campaignData.CampaignID + "_createcpopup" : "createcpopup"}`}
        data={campaignData}
      ></DuplicateCampaignPage>,
      callback,
    );
  };
  static launchEditCampaignPopup = (campaignData, callback = () => {}) => {
    PopupManager.onModalUpdate(
      true,
      <CreateCampaignPage
        key={`${campaignData ? campaignData.CampaignID + "_createcpopup" : "createcpopup"}`}
        data={campaignData}
      ></CreateCampaignPage>,
      callback,
    );
  };
  static launchAssignAndPublishPopup = (campaignData, callback = () => {}) => {
    PopupManager.onModalUpdate(
      true,
      <AssignAndPublishPage
        key={`${campaignData ? campaignData.CampaignID + "_assignpopup" : "assignpopup"}`}
        campaignData={campaignData}
      ></AssignAndPublishPage>,
      callback,
    );
  };

  static launchPlaylistPublishPopup = (playlistData, callback = () => {}) => {
    PopupManager.onModalUpdate(
      true,
      <AssignAndPublishPage
        key={`${playlistData ? playlistData.PlaylistID + "_assignpopup" : "assignpopup"}`}
        playlistData={playlistData}
      ></AssignAndPublishPage>,
      callback,
    );
  };
  static launchAssignAndPublishEventPopup = (
    eventPlaylistData,
    callback = () => {},
  ) => {
    PopupManager.onModalUpdate(
      true,
      <AssignAndPublishEventPage
        eventPlaylistData={eventPlaylistData}
      ></AssignAndPublishEventPage>,
      callback,
    );
  };
  static launchDuplicateTimelinePopup = (
    timelineData,
    campaignData,
    callback = () => {},
  ) => {
    PopupManager.onModalUpdate(
      true,
      <DuplicateTimelinePage
        key={`${timelineData ? timelineData.TimelineID + "_createcpopup" : "createcpopup"}`}
        data={timelineData}
        campaignData={campaignData}
      ></DuplicateTimelinePage>,
      callback,
    );
  };
  static launchCreateTimelinePopup = (campaignData, callback = () => {}) => {
    // console.log("launchCreateTimelinePopup " + JSON.stringify(campaignData))
    PopupManager.onModalUpdate(
      true,
      <CreateTimelinePage
        key={"createtimeline" + Math.random()}
        campaignData={campaignData}
      ></CreateTimelinePage>,
      callback,
    );
  };
  static launchCreateEventTimelinePopup = (
    campaignData,
    callback = () => {},
  ) => {
    PopupManager.onModalUpdate(
      true,
      <CreateEventTimelinePage
        key={"createeventtimeline" + Math.random()}
        campaignData={campaignData}
      ></CreateEventTimelinePage>,
      callback,
    );
  };
  static launchCreateWidgetInstancePopup = (
    widgetData,
    callback = () => {},
  ) => {
    PopupManager.onModalUpdate(
      true,
      <CreateWidgetInstancePage
        key={`${widgetData ? widgetData.WidgetID + "_createcpopup" : "createcpopup"}`}
        widgetData={widgetData}
      ></CreateWidgetInstancePage>,
      callback,
    );
  };
  static launchEditTimelinePopup = (
    timelineData,
    campaignData,
    callback = () => {},
  ) => {
    PopupManager.onModalUpdate(
      true,
      <CreateTimelinePage
        key={`${timelineData ? timelineData.TimelineID + "_createcpopup" : "createcpopup"}`}
        data={timelineData}
        campaignData={campaignData}
      ></CreateTimelinePage>,
      callback,
    );
  };
  static launchCreateBrandPopup = (callback = () => {}) => {
    PopupManager.onModalUpdate(
      true,
      <CreateBrandPage key={"createbrand" + Math.random()}></CreateBrandPage>,
      callback,
    );
  };
  static launchEditBrandPopup = (brandData, callback = () => {}) => {
    PopupManager.onModalUpdate(
      true,
      <CreateBrandPage
        key={`${brandData ? brandData.BrandID + "_createcpopup" : "createcpopup"}`}
        data={brandData}
      ></CreateBrandPage>,
      callback,
    );
  };
  static launchCreateBranchPopup = (callback = () => {}) => {
    PopupManager.onModalUpdate(
      true,
      <CreateBranchPage
        key={"createbranch" + Math.random()}
      ></CreateBranchPage>,
      callback,
    );
  };
  static launchEditBranchPopup = (branchData, callback = () => {}) => {
    PopupManager.onModalUpdate(
      true,
      <CreateBranchPage
        key={"editbranch" + Math.random()}
        data={branchData}
      ></CreateBranchPage>,
      callback,
    );
  };
  static launchCreateScreenPopup = (callback = () => {}) => {
    PopupManager.onModalUpdate(
      true,
      <CreateScreenPage
        key={"createscreen" + Math.random()}
        onSuccess={callback}
      ></CreateScreenPage>,
      () => {},
    );
  };
  static launchCreateScreenEventPopup = (callback = () => {}, data) => {
    PopupManager.onModalUpdate(
      true,
      <CreateScreenEventPage
        key={"createscreenevent" + Math.random()}
        data={data}
      ></CreateScreenEventPage>,
      callback,
    );
  };
  static launchCreateScreenEventPlaylistPopup = (
    callback = () => {},
    screenData,
    eventTypesData,
  ) => {
    PopupManager.onModalUpdate(
      true,
      <ScreenEventPlaylistModuleEditor
        key={"ScreenEventPlaylistModuleEditor" + Math.random()}
        data={{
          WeekDay: "0,1,2,3,4,5,6",
          StartDate: "",
          EndDate: "",
          StartTime: "",
          EndTime: "",
        }}
        screenData={screenData}
        eventTypes={eventTypesData}
      ></ScreenEventPlaylistModuleEditor>,
      callback,
    );
  };
  static launchEditScreenPopup = (screenData, callback = () => {}) => {
    PopupManager.onModalUpdate(
      true,
      <CreateScreenPage
        key={"updateScreen" + Math.random()}
        data={screenData}
      ></CreateScreenPage>,
      () => {
        console.log(
          "[EditScreen] afterClose _savedOnClose=",
          PopupManager._savedOnClose,
        );
        if (PopupManager._savedOnClose) {
          PopupManager._savedOnClose = false;
          callback();
        }
      },
    );
  };
  static launchEditScreenBrightnessPopup = (
    screenData,
    callback = () => {},
  ) => {
    PopupManager.onModalUpdate(
      true,
      <ScreenBrightnessPage
        key={`${screenData ? screenData.ScreenID + "_brightnesscpopup" : "brightnesscpopup"}`}
        data={screenData}
      ></ScreenBrightnessPage>,
      callback,
    );
  };
  static launchEditScreenEventPopup = (data, callback = () => {}) => {
    PopupManager.onModalUpdate(
      true,
      <CreateScreenEventPage
        key={"editscreenevent" + Math.random()}
        data={data}
      ></CreateScreenEventPage>,
      callback,
    );
  };
  static closePopup = (saved = false) => {
    PopupManager._savedOnClose = saved === true;
    PopupManager.onModalUpdate(false, null);
  };
}

export default PopupManager;
